  <div
    class="header h-[55px] flex justify-start items-center pl-[50px] mb-[10px] bg-[#F1F3F5]"
  >
    <p class="!m-0">{{ projectName }} - Request for Proposal (RFP)</p>
    <p
      class="!mt-[10px] bg-white !ml-[15px] flex items-center justify-center tag"
    >
      Technical Evaluation Criteria
    </p>
  </div>
  <div class="!pl-[50px] !mb-[15px]">
    <div class=" text-[1rem] text-[#343A40] font-semibold">
      Instructions for Technical Evaluation Weightage Allocation
    </div>
    <p calss="text-[14px] pl-[50px]">Assign a percentage to every field, ensuring the total equals 100%. No field should be left blank, and incomplete distributions will not be accepted.</p>
  </div>
  
  <div class="!pl-[50px] !mb-[15px] text-[1rem] text-[#343A40] font-semibold">
    Enter Weightage
  </div>
  <div class="!pl-[50px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Understanding of Scope and Objectives</mat-label>
          <input
            matInput
            type="number"
            [formControl]="understandingOfScopeAndObjectivesControl"
            placeholder="Enter Weightage"
          />
          <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1px]" matSuffix [style.opacity]="understandingOfScopeAndObjectivesControl.value ? '1' : '0'">percent</mat-icon>
        </mat-form-field>
        <mat-error
          *ngIf="understandingOfScopeAndObjectivesControl.invalid && understandingOfScopeAndObjectivesControl.touched"
          class="relative top-[-15px]"
        >
          Weight for Understanding of Scope and Objectives is required.
        </mat-error>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Proposed Methodology and Approach</mat-label>
          <input
            matInput
            type="number"
            [formControl]="proposedMethodologyAndApproachControl"
            placeholder="Enter Weightage"
          />
          <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1.5px]" matSuffix [style.opacity]="proposedMethodologyAndApproachControl.value ? '1' : '0'">percent</mat-icon>

        </mat-form-field>
        <mat-error
          *ngIf="proposedMethodologyAndApproachControl.invalid && proposedMethodologyAndApproachControl.touched"
          class="relative top-[-15px]"
        >
          Weight for Proposed Methodology and Approach is required.
        </mat-error>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Team and Resource Capability</mat-label>
          <input
            matInput
            type="number"
            [formControl]="teamAndResourceCapabilityControl"
            placeholder="Enter Weightage"
          />
          <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1px]" matSuffix [style.opacity]="teamAndResourceCapabilityControl.value ? '1' : '0'">percent</mat-icon>
        </mat-form-field>
        <mat-error
          *ngIf="teamAndResourceCapabilityControl.invalid && teamAndResourceCapabilityControl.touched"
          class="relative top-[-15px]"
        >
          Weight for Team and Resource Capability is required.
        </mat-error>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Quality Assurance and Risk Management</mat-label>
          <input
            matInput
            type="number"
            [formControl]="qualityAssuranceAndRiskManagementControl"
            placeholder="Enter Weightage"
          />
          <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1.5px]" matSuffix [style.opacity]="qualityAssuranceAndRiskManagementControl.value ? '1' : '0'">percent</mat-icon>
        </mat-form-field>
        <mat-error
          *ngIf="qualityAssuranceAndRiskManagementControl.invalid && qualityAssuranceAndRiskManagementControl.touched"
          class="relative top-[-15px]"
        >
          Weight for Quality Assurance and Risk Management is required.
        </mat-error>
      </div>
    </div>

    <div class="p-0">
      <div class="rounded p-0 !pb-0 !pt-0" style="margin-right: 66px">
        <mat-form-field class="!w-[100%]" appearance="outline">
          <mat-label>Added Value and Sustainability</mat-label>
          <input
            matInput
            type="number"
            [formControl]="addedValueAndSustainabilityControl"
            placeholder="Enter Weightage"
          />
          <mat-icon class="!h-[52.5px] mb-[0.5px] justify-center !content-center rounded-r-[4px]  bg-gray-200 !mr-[1px]" matSuffix [style.opacity]="addedValueAndSustainabilityControl.value ? '1' : '0'">percent</mat-icon>
        </mat-form-field>
        <mat-error
          *ngIf="addedValueAndSustainabilityControl.invalid && addedValueAndSustainabilityControl.touched"
          class="relative top-[-15px]"
        >
          Weight for Added Value and Sustainability is required.
        </mat-error>
      </div>
    </div>
    
    <p class="item-center justify-center " [ngClass]="{ 'text-[#EE4B2B]': totalWeight > 100,'text-[#505255]': totalWeight < 100, 'text-green-500': totalWeight === 100 }">
      Total Weightage: {{ totalWeight }} %
    </p>

  </div>
  <!-- Back and next Buttons -->
  <div
    class="relative bottom-0 right-0 !pr-[66px] !mb-[30px] !mt-[49px] grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 gap-4"
  >
    <div class="!w-[100%] flex justify-end items-center">
      <button (click)="moveToPreviousStep()" type="button" class="back-btn">
        Back
      </button>
      <button
        class="!w-[75px] !h-[39px] flex justify-center items-center !bg-[#E76B3F] !text-[#ffffff] !text-[16px] !rounded-[3px]"
        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        (click)="moveToNextStep()"
      >
        Next
      </button>
    </div>
  </div>
